import styled from 'styled-components'

interface ButtonProps {
  width?: string
  height?: string
}

export const Button = styled.input<ButtonProps>`
  outline-color: #002d63;
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  border: 1px solid #c7c9c7;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : '#25a37b')};
  font-weight: bold;
`
